export { Image } from '@mantine/core'
